import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaBoxesStacked, FaRegImages, FaGear } from "react-icons/fa6";
import MenuMobile from '@components/ui/MenuMobile/MenuMobile';
import FloatingMenu from "@components/ui/FloatingMenu/FloatingMenu";
import './Footer.scss';

type FooterProps = {};

function Footer(props: FooterProps) {
    const location = useLocation();
    const { t } = useTranslation();

    // const inConfigModel = location.pathname.substring(0, 3) === '/m/';
    // const split = location.pathname.split('/');
    // split.shift();

    return (
        <footer className="d-md-none">
            <MenuMobile items={[
                {
                    label: t('menu.lumebas'),
                    icon: FaBoxesStacked,
                    to: '/',
                    active: location.pathname === '/' || location.pathname.includes('/m/'),
                },
                {
                    label: t('menu.screenshots'),
                    icon: FaRegImages,
                    to: '/screenshots',
                    active: location.pathname === '/screenshots',
                },
                {
                    label: t('menu.settings'),
                    icon: FaGear,
                    to: '/settings',
                    active: location.pathname.includes('/settings') || location.pathname === '/changelog',
                },
            ]}/>
        </footer>
    );
}

export default Footer;
